import { render, staticRenderFns } from "./SlrcD_InvList_PaytSummaryList.vue?vue&type=template&id=0c0fcbbf"
import script from "./SlrcD_InvList_PaytSummaryList.vue?vue&type=script&lang=js"
export * from "./SlrcD_InvList_PaytSummaryList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports